class GtagCustomEvents {

    constructor() {

        this.events();
    }

    events() {
        let self = this;

        $(document).on('click', '.gtag-custom-event', function () {

            let category = $(this).data('gtag-category'),
                label = $(this).data('gtag-label');

            if (typeof gtag != "undefined" &&
                typeof category != "undefined" &&
                typeof label != "undefined") {

                gtag("event", "CustomEvents", {
                    'event_category': category,
                    'event_label': label
                });
            }
        });
    }
}

new GtagCustomEvents();